export default __webpack_public_path__ + "static/bed_w.a60a66cd8e2f96b57a87fa008a341dc6.png";